import i18n from '@/plugins/i18n';

function getManagementColumns(handlers) {
  return getColumns(handlers, managementColumns);
}
function getApprovalRequestColumns(handlers) {
  return getColumns(handlers, approvalRequestColumns);
}

function getAdminColumns(handlers) {
  return getColumns(handlers, adminColumns);
}

function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const managementColumns = [
  {
    text: i18n.t("label.member_name"),
    value: "name",
    sortBy: "name",
    type: "text",
  },
  {
    text: i18n.t("label.member_email"),
    value: "email",
    sortBy: "email",
    type: "text",
  },
  {
    text: i18n.t("label.member_phone"),
    value: "phone",
    type: "text",
  },
  {
    text: i18n.t("label.member_created_at"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "description",
        color: "primary",
        key: "showDetail",
        handler: null,
      },
      {
        icon: "person_off",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

const approvalRequestColumns = [
  {
    text: i18n.t("label.member_name"),
    value: "name",
    sortBy: "name",
    type: "text",
  },
  {
    text: i18n.t("label.member_email"),
    value: "email",
    sortBy: "email",
    type: "text",
  },
  {
    text: i18n.t("label.member_phone"),
    value: "phone",
    type: "text",
  },
  {
    text: i18n.t("label.member_created_at"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.member_detail"),
    type: "button",
    actions: [
      {
        icon: "description",
        color: "primary",
        key: "showDetail",
        handler: null,
      },
    ],
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "person_add",
        color: "green",
        key: "accept",
        handler: null,
      },
      {
        icon: "person_off",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

const adminColumns = [
  {
    text: i18n.t("label.member_name"),
    value: "name",
    sortBy: "name",
    type: "text",
  },
  {
    text: i18n.t("label.member_email"),
    value: "email",
    sortBy: "email",
    type: "text",
  },
  {
    text: i18n.t("label.member_organization"),
    value: "organization",
    type: "text",
  },
  {
    text: i18n.t("label.member_department"),
    value: "department",
    type: "text",
  },
  {
    text: i18n.t("label.member_current_role"),
    value: "admin_types",
    readonly: true,
    type: "chip",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "description",
        color: "green",
        key: "showDetail",
        handler: null,
      },
      {
        icon: "add",
        color: "primary",
        key: "addRole",
        handler: null,
      },
      {
        icon: "delete",
        color: "red",
        key: "deleteRole",
        handler: null,
      },
    ],
  },
];

export { getManagementColumns, getApprovalRequestColumns, getAdminColumns };
